// extracted by mini-css-extract-plugin
export default {"root":"ManageAccountPage_root__NTtWa","reducedHeight":"ManageAccountPage_reducedHeight__jjJuL","container":"ManageAccountPage_container__ns+9j"};